import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="copy-to-clipboard"
export default class extends Controller {
  static targets = ["input", "toast"]

  connect() {
  }

  copy() {
    var inputField = this.inputTarget
    inputField.select();
    inputField.setSelectionRange(0, 99999); // Für mobile Geräte

    try {
      navigator.clipboard.writeText(inputField.value);
      this.displayToast()
    } catch (err) {
      alert("Kopieren nicht möglich. Bitte manuell kopieren.");
    }
  }

  // private

  displayToast() {
    const toast = this.toastTarget;
    toast.classList.remove("opacity-0");
    toast.classList.add("opacity-100");

    setTimeout(() => {
      toast.classList.remove("opacity-100");
      toast.classList.add("opacity-0");
    }, 2000);
  }
}
